import { AccessChecker } from 'mycorems-app-accounts';
import rules from './rules';

// This object must be loaded at runtime to allow config
// to be passed at runtime
let accessChecker;
function getAccessChecker(): AccessChecker {
  if (!accessChecker) {
    accessChecker = new AccessChecker(rules, window.env.MYCOREMS_BILLING.SERVICE_NAME);
  }
  return accessChecker;
}

export default function (action: string, ...args: any[]): boolean {
  return getAccessChecker().isGranted(action, ...args);
}
